// extracted by mini-css-extract-plugin
export default {"createTaskModal_content":"CreateTaskModal_createTaskModal_content__zMWyo"};